module.exports = __webpack_public_path__ + "static/blazonUI-97998988bb76257c4e27d557e22a9521.png";